import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Form from "react-validation/build/form";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import logo from "./../assets/logofinal.svg";
import LoginBG from "./../assets/hintergrund.jpg";
import AuthService from "../services/auth.service";

const Signup = () => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [secret, setSecret] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const signupcode = params.get("signupcode");
    const email = params.get("email");
    const vorname = params.get("firstname")
    const lastname = params.get("lastname")

    if (signupcode) {
      setSecret(signupcode);
    }

    if (email) {
      setEmail(email);
    }

    if (vorname) {
      setFirstname(vorname);
    }

    if (lastname) {
      setLastname(lastname);
    }

  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    const signup = await AuthService.register(
      firstname,
      lastname,
      phone,
      mobile,
      email,
      password,
      secret
    );

    if (signup.type === "error") {
      setMessage(
        <Alert severity="error">
          <Typography variant="h6">Fehler</Typography>
          {signup.message}
        </Alert>
      );
    } else {
      setMessage(
        <Alert severity="success">
          <Typography variant="h6">Aktion erfolgreich</Typography>
          Sie wurden erfolgreich registriert. Wir leiten Sie zur Anmeldung zurück...
        </Alert>
      );

      setFirstname("");
      setLastname("");
      setPhone("");
      setMobile("");
      setEmail("");
      setPassword("");
      setSecret("");

      setTimeout(() => {
        navigate("/login");
      }, 4000);
    }
  };

  return (
    <Grid container component="main">
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: `url(${LoginBG})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: "#f0f2f5",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Grid container xs={12} sm={8} md={5}>
        <Box
          sx={{
            my: 6,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <img style={{ marginBottom: "20px" }} src={logo} alt="Logo" />
            <Typography variant="h4">Kundenportal - Registrierung</Typography>
          </Box>
          <Form onSubmit={handleSubmit} style={{ width: "80%" }}>
            <Grid container spacing={2} my={4}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <TextField
                    required
                    label="Vorname"
                    type="text"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                    variant="outlined"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <TextField
                    required
                    label="Nachname"
                    type="text"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                    variant="outlined"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6">Kontaktdaten</Typography>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Telefon"
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    variant="outlined"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <TextField
                    required
                    label="Mobil"
                    type="text"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    variant="outlined"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    required
                    label="E-Mail"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    variant="outlined"
                  />
                </FormControl>
              </Grid>              
              <Grid item xs={12}>
                <Typography variant="h6">Account</Typography>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    required
                    label="Ihr Passwort"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    variant="outlined"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    required
                    label="Anmeldecode"
                    type="text"
                    value={secret}
                    onChange={(e) => setSecret(e.target.value)}
                    variant="outlined"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                {message}
              </Grid>
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <Button type="submit" variant="contained">
                  Anlegen
                </Button>
              </Grid>
            </Grid>
          </Form>
          <Typography variant="body2" color="text.secondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://www.der-finanzierer.com/">
              Oliver Scholl - Der FINanzierer.com
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Signup;
